
import { APIDomainVersion } from "../models/site.model";

export class General {
    static appName = "AndDone API Explorer";
    static defaultDomainVersion:APIDomainVersion = 'secure_2.3';
    static defaultVersion = 2.3;
    static clientLibraryURLs = {
        "php": "https://github.com/AndDone-LLC/AndDone-SecureAPI-ClientLibrary-PHP",
        "ruby": "https://github.com/AndDone-LLC/AndDone-SecureAPI-ClientLibrary-Ruby",
        "dotnet": "https://github.com/AndDone-LLC/AndDone-SecureAPI-ClientLibrary-DotNet",
        "python": "https://github.com/AndDone-LLC/AndDone-SecureAPI-ClientLibrary-Python",
        "go": "https://github.com/AndDone-LLC/AndDone-SecureAPI-ClientLibrary-Go",
        "nodejs": "https://github.com/AndDone-LLC/AndDone-SecureAPI-ClientLibrary-NodeJS",
    }
}

